import React from "react";
import AppBreadcrumbs from "../../../../components/AppBreadcrumbs";
import DocsSectionCard from "../../shared/DocsSectionCard";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";

const noop = () => {};

const previewItems = [
  { label: "Dashboard", onClick: noop },
  { label: "Formulare", onClick: noop },
  { label: "Neues Formular" },
];

const niceToKnowItems = [
  "Breadcrumbs erscheinen nur in der Topbar.",
  "Ein einzelner Eintrag wird nicht angezeigt.",
  "Der letzte Eintrag ist die aktuelle Seite.",
  "Labels werden bei zu wenig Platz automatisch gekürzt.",
];

export default function BreadcrumbsDocs() {
  return (
    <DocsSectionCard title="Breadcrumbs">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface">
            <AppBreadcrumbs items={previewItems} />
          </div>
        </DocsPreviewPanel>
        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
